import { type Option } from 'src/types'

const combatOptions: Option[] = [
  {
    text: 'attack',
    effects: {}
  },
  {
    text: 'defend',
    effects: {}
  },
  {
    text: 'run',
    effects: {}
  }
]

const victoryOptions: Option[] = [
  {
    text: 'loot',
    logs: [
      {
        text: 'You checked the enemy for some loot...'
      }
    ],
    effects: {}
  },
  {
    text: 'kill',
    logs: [
      {
        text: 'You took one final look at your enemy and claimed its life.',
        omen: 'bad'
      }
    ],
    effects: {
      counters: {
        player_karma: {
          '-': 100
        }
      }
    }
  },
  {
    text: 'spare',
    logs: [
      {
        text: 'You had mercy for your enemy and spared its life.',
        omen: 'good'
      }
    ],
    effects: {
      counters: {
        player_karma: {
          '+': 2
        }
      }
    }
  }
]

const leave: Option = {
  text: 'leave',
  effects: {}
}

const defeatOptions: Option[] = [
  {
    text: 'let go',
    logs: [
      {
        text: 'Lights faded, and you passed out.',
        omen: 'bad'
      }
    ],
    effects: {
      counters: {
        player_deaths: {
          '+': 1
        }
      }
    }
  }
]

export {
  combatOptions,
  victoryOptions,
  defeatOptions,
  leave
}
